import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
type IconProps = {
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
};
function YelpIcon({
  className,
  ...rest
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} {...rest} data-id="element-254" data-mp="36qhgexuv642s">
      <path d="m7.6885 15.1415-3.6715.8483c-.3769.0871-.755.183-1.1452.155-.2611-.0188-.5122-.0414-.7606-.213a1.179 1.179 0 0 1-.331-.3594c-.3486-.5519-.3656-1.3661-.3697-2.0004a6.2874 6.2874 0 0 1 .3314-2.0642 1.857 1.857 0 0 1 .1073-.2474 2.3426 2.3426 0 0 1 .1255-.2165 2.4572 2.4572 0 0 1 .1563-.1975 1.1736 1.1736 0 0 1 .399-.2831 1.082 1.082 0 0 1 .4592-.0837c.2355.0016.5139.052.91.1734.0555.0191.1237.0382.1856.0572.3277.1013.7048.2404 1.1499.3987.6863.2404 1.3663.487 2.0463.7397l1.2117.4423c.2217.0807.4363.18.6412.297.174.0984.3273.2298.4512.387a1.217 1.217 0 0 1 .192.4309 1.2205 1.2205 0 0 1-.872 1.4522c-.0468.0151-.0852.0239-.1085.0293l-1.105.2553-.0031-.001zM18.8208 7.565a1.8506 1.8506 0 0 0-.2042-.1754 2.4082 2.4082 0 0 0-.2077-.1394 2.3607 2.3607 0 0 0-.2269-.109 1.1705 1.1705 0 0 0-.482-.0796 1.0862 1.0862 0 0 0-.4498.1263c-.2107.1048-.4388.2732-.742.5551-.042.0417-.0947.0886-.142.133-.2502.2351-.5286.5252-.8599.863a114.6363 114.6363 0 0 0-1.5166 1.5629l-.8962.9293a4.1897 4.1897 0 0 0-.4466.5483 1.541 1.541 0 0 0-.2364.5459 1.2199 1.2199 0 0 0 .0107.4518l.0046.02a1.218 1.218 0 0 0 1.4184.923 1.162 1.162 0 0 0 .1105-.0213l4.7781-1.104c.3766-.087.7587-.1667 1.097-.3631.2269-.1316.4428-.262.5909-.5252a1.1793 1.1793 0 0 0 .1405-.4683c.0733-.6512-.2668-1.3908-.5403-1.963a6.2792 6.2792 0 0 0-1.2001-1.7103zM8.9703.0754a8.6724 8.6724 0 0 0-.83.1564c-.2754.066-.548.1383-.8146.2236-.868.2844-2.0884.8063-2.295 1.8065-.1165.5655.1595 1.1439.3737 1.66.2595.6254.614 1.1889.9373 1.7777.8543 1.5545 1.7245 3.0993 2.5922 4.6457.259.4617.5416 1.0464 1.043 1.2856a1.058 1.058 0 0 0 .1013.0383c.2248.0851.4699.1016.7041.0471a4.3015 4.3015 0 0 0 .0418-.0097 1.2136 1.2136 0 0 0 .5658-.3397 1.1033 1.1033 0 0 0 .079-.0822c.3463-.435.3454-1.0833.3764-1.6134.1042-1.771.2139-3.5423.3009-5.3142.0332-.6712.1055-1.3333.0655-2.0096-.0328-.5579-.0368-1.1984-.3891-1.6563-.6218-.8073-1.9476-.741-2.8523-.6158zm2.084 15.9505a1.1053 1.1053 0 0 0-1.2306-.4145 1.1398 1.1398 0 0 0-.1526.0633 1.4806 1.4806 0 0 0-.2171.1354c-.1992.1475-.3668.3392-.5196.5315-.0386.049-.074.1143-.12.1562l-.7686 1.0573a113.9168 113.9168 0 0 0-1.2913 1.789c-.278.3895-.5184.7184-.7083 1.0094-.036.0547-.0734.116-.1075.1647-.2277.3522-.3566.6092-.4228.8381a1.0945 1.0945 0 0 0-.046.4721c.0211.1655.0768.3246.1635.467.046.0715.0957.1406.1487.207a2.334 2.334 0 0 0 .1754.1825 1.843 1.843 0 0 0 .2108.1732c.5304.369 1.1112.6342 1.722.8391a6.0958 6.0958 0 0 0 1.5716.3004c.091.0046.1821.0025.2728-.006a2.3878 2.3878 0 0 0 .2506-.0351 2.3862 2.3862 0 0 0 .2447-.071 1.1927 1.1927 0 0 0 .4175-.2658c.1127-.113.1994-.249.2541-.3989.0889-.2214.1473-.5026.1857-.92.0034-.0593.0118-.1305.0177-.1958.0304-.3463.0443-.7531.0666-1.2315.0375-.7357.067-1.4681.0903-2.2026 0 0 .0495-1.3053.0494-1.306.0113-.3008.002-.6342-.0814-.9336a1.396 1.396 0 0 0-.1756-.4054zm8.6754 2.0439c-.1605-.176-.3878-.3514-.7462-.5682-.0518-.0288-.1124-.0674-.1684-.1009-.2985-.1795-.658-.3684-1.078-.5965a120.7615 120.7615 0 0 0-1.9427-1.042l-1.1515-.6107c-.0597-.0175-.1203-.0607-.1766-.0878-.2212-.1058-.4558-.2045-.6992-.2498a1.4915 1.4915 0 0 0-.2545-.0265 1.1527 1.1527 0 0 0-.1648.01 1.1077 1.1077 0 0 0-.9227.9133 1.4186 1.4186 0 0 0 .0159.439c.0563.3065.1932.6096.3346.875l.615 1.1526c.3422.65.6884 1.2963 1.0435 1.9406.229.4202.4196.7799.5982 1.078.0338.056.0721.1163.1011.1682.2173.3584.392.584.569.7458.1146.1107.252.195.4026.247.1583.0525.326.071.4919.0546a2.368 2.368 0 0 0 .251-.0435c.0817-.022.1622-.048.241-.0784a1.863 1.863 0 0 0 .2475-.1143 6.1018 6.1018 0 0 0 1.2818-.9597c.4596-.4522.8659-.9454 1.182-1.51.044-.08.0819-.163.1138-.2483a2.49 2.49 0 0 0 .0773-.2411c.0186-.083.033-.1669.0429-.2513a1.188 1.188 0 0 0-.0565-.491 1.0933 1.0933 0 0 0-.248-.4041zm2.86 3.742a.8523.8523 0 0 1-.111.4236c-.074.132-.178.2377-.3115.3172a.8428.8428 0 0 1-.4385.119.847.847 0 0 1-.4373-.1179.8526.8526 0 0 1-.3125-.3171.8548.8548 0 0 1-.111-.4248c0-.1526.038-.2958.1143-.4294a.8405.8405 0 0 1 .315-.3159.849.849 0 0 1 .4315-.1156.8514.8514 0 0 1 .4294.1144.84.84 0 0 1 .316.3148.8494.8494 0 0 1 .1156.4317zm-.1202 0c0-.1328-.0332-.256-.0996-.3698s-.1564-.2038-.2702-.2702a.7125.7125 0 0 0-.371-.1007.7204.7204 0 0 0-.3698.0996.7487.7487 0 0 0-.2713.2702.7181.7181 0 0 0-.0996.3709c0 .132.0332.2557.0996.371a.7355.7355 0 0 0 .2713.2713.7354.7354 0 0 0 .3698.0985.7205.7205 0 0 0 .3698-.0996.7423.7423 0 0 0 .2702-.2691.7186.7186 0 0 0 .1008-.3721zm-.577.0584.2724.4522h-.1922l-.237-.4052h-.1546v.4052h-.1695v-1.02h.2988c.1268 0 .2195.0247.2783.0744.0595.0496.0892.1252.0892.2267a.2785.2785 0 0 1-.0492.1625c-.032.0466-.0775.0813-.1362.1042zm-.0412-.1408a.1532.1532 0 0 0 .056-.1214c0-.0573-.0164-.0981-.0491-.1225-.0329-.0251-.0847-.0377-.1557-.0377h-.1214v.3285h.1237c.061 0 .1098-.0157.1465-.047z" data-id="element-255" data-mp="3ueiltxwqx4dz" />
    </svg>;
}
function GoogleIcon({
  className,
  ...rest
}: IconProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={className} {...rest} data-id="element-256" data-mp="1wm455t0dimun">
      <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-257" data-mp="1rom1ah17qxti" />
    </svg>;
}

/* 2026-09-15 (Kevin, three-services restructure): added What it fixes,
   Yelp Ads, and Websites -- the new real routes -- to the footer's page
   list alongside the existing nav. */
const nav = [{
  to: '/',
  label: 'Home'
}, {
  to: '/what-it-fixes',
  label: 'What it fixes'
}, {
  to: '/how-it-works',
  label: 'How it works'
}, {
  to: '/getting-started',
  label: 'Getting started'
}, {
  to: '/why',
  label: 'Why Viridia'
}, {
  to: '/pricing',
  label: 'Pricing'
}, {
  to: '/yelp-ads',
  label: 'Yelp Ads'
}, {
  to: '/websites',
  label: 'Websites'
}, {
  to: '/contact',
  label: 'Book a call'
}, {
  to: '/blog',
  label: 'Blog'
}, {
  to: '/case-studies',
  label: 'Case studies'
}];

/* 2026-09-17 (local search build): a second footer column so every page
   on the site links to the six local-search pages. This is the sitewide
   internal link the map-pack and exact-match pages need. */
const local = [{
  to: '/answering-service-phoenix',
  label: 'Answering service in Phoenix'
}, {
  to: '/answering-service-for-contractors',
  label: 'Answering service for contractors'
}, {
  to: '/best-answering-service-for-small-business',
  label: 'Best answering service for small business'
}, {
  to: '/missed-call-text-back',
  label: 'Missed-call text-back'
}, {
  to: '/crm-for-contractors',
  label: 'CRM for contractors'
}, {
  to: '/google-business-profile-setup',
  label: 'Google Business Profile setup'
}];
const socials = [{
  label: 'Facebook',
  href: 'https://www.facebook.com/profile.php?id=61571074363261',
  Icon: FacebookIcon
}, {
  label: 'Instagram',
  href: 'https://www.instagram.com/viridiaanalyticsllc/',
  Icon: InstagramIcon
}, {
  label: 'LinkedIn',
  href: 'https://www.linkedin.com/company/viridia-analytics/',
  Icon: LinkedinIcon
}, {
  label: 'Yelp',
  href: 'https://www.yelp.com/biz/viridia-analytics-phoenix-2',
  Icon: YelpIcon
}, {
  label: 'Google Business Profile',
  href: 'https://share.google/7uhXXh31DmLvspcqP',
  Icon: GoogleIcon
}];
export function Footer() {
  return <footer className="bg-[#0a0a0a]" data-id="element-258" data-mp="efg1f47cqgv5">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-12 px-6 py-16 sm:grid-cols-2 lg:grid-cols-[1.3fr_0.7fr_1fr_0.9fr] lg:gap-10" data-id="element-259" data-mp="2dqh5jxrxg2la">
        <div className="sm:col-span-2 lg:col-span-1" data-id="element-260" data-mp="28rw7a3w8jszh">
          <div className="flex items-center gap-3" data-id="element-261" data-mp="1hliff0ojij5x">
            <img src="https://cdn.magicpatterns.com/uploads/dBgonnHgNocdZqWCx2rT29/VA-Logo_(1).png" alt="Viridia Analytics logo" className="h-9 w-9 object-contain" data-id="element-262" data-mp="1hnv2fs95njpu" />
            <span className="text-sm font-semibold text-white" data-id="element-263" data-mp="1cv1xb39ry9d8">Viridia Analytics</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-neutral-500" data-id="element-264" data-mp="yvitunrwrm79">
            We help local service businesses stop missing leads, respond instantly, and book more
            jobs.
          </p>

          <ul className="mt-6 flex flex-wrap items-center gap-3" data-id="element-265" data-mp="oxmipvyz0r95">
            {socials.map(({
            label,
            href,
            Icon
          }) => <li key={label} data-id="element-266" data-mp="tx8zughx6rn8">
                <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label} className="flex h-10 w-10 items-center justify-center rounded-full border border-[#1f1f1f] text-neutral-400 transition-colors hover:border-emerald-500/60 hover:text-emerald-500" data-id="element-267" data-mp="tya9qhn7983d">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-268" data-mp="7lxtpc2n4g2d" />
                </a>
              </li>)}
          </ul>

          <div className="mt-8 inline-block rounded-xl bg-white p-3" data-id="element-269" data-mp="hlevhieru9t2">
            <a href="https://scottsdalechamber.chambermaster.com/mic/members/details/viridia-analytics-llc-40182?memId=40182&repId=81499" target="_blank" rel="noopener noreferrer" className="block" data-id="element-270" data-mp="hk3vzusczo7r">
              <img src="https://cdn.magicpatterns.com/uploads/8HQjTNAJm388sm9my7xsCp/Scotsscommerce.png" alt="Viridia Analytics is a Scottsdale Area Chamber of Commerce member" className="h-10 w-auto object-contain" data-id="element-271" data-mp="15b0xedmj334r" />
            </a>
          </div>
        </div>

        <nav aria-label="Footer" data-id="element-272" data-mp="3265mro6dzft4">
          <h2 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-600" data-id="element-273" data-mp="iurv9la3b2zs">
            Pages
          </h2>
          <ul className="mt-4 space-y-3" data-id="element-274" data-mp="duchislwbtha">
            {nav.map(l => <li key={l.to} data-id="element-275" data-mp="8vj4t2efo6i6">
                <Link to={l.to} className="text-sm text-neutral-400 transition-colors hover:text-white" data-id="element-276" data-mp="8wkpzzp5y9dm">
                  {l.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <nav aria-label="Local search pages" data-id="element-277" data-mp="wlddd7rpz8wm">
          <h2 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-600" data-id="element-278" data-mp="wmeyk52g9bs2">
            Phoenix
          </h2>
          <ul className="mt-4 space-y-3" data-id="element-279" data-mp="mvtsxxocz6zn">
            {local.map(l => <li key={l.to} data-id="element-280" data-mp="mtr7lqy5i219">
                <Link to={l.to} className="text-sm text-neutral-400 transition-colors hover:text-white" data-id="element-281" data-mp="1kaxzu0n30oan">
                  {l.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-282" data-mp="1nv886kcz9adj">
          <h2 className="font-mono text-xs uppercase tracking-[0.18em] text-neutral-600" data-id="element-283" data-mp="1ruqqd8dez7co">
            Contact
          </h2>
          <ul className="mt-4 space-y-3 text-sm text-neutral-400" data-id="element-284" data-mp="1wtadvd7nor75">
            <li className="flex items-center gap-2.5" data-id="element-285" data-mp="1ww6bt1ji7fvl">
              <PhoneIcon className="h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-286" data-mp="21tpqu3o0zwol" />
              <a href="tel:6233000708" className="hover:text-white" data-id="element-287" data-mp="26qyc4d4h0gu2">
                (623) 300-0708
              </a>
            </li>
            <li className="flex items-center gap-2.5" data-id="element-288" data-mp="2ari5r6pu52bg">
              <MailIcon className="h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-289" data-mp="2fk1mgcjtkdkh" />
              <a href="mailto:info@viridiaanalytics.com" className="hover:text-white" data-id="element-290" data-mp="2kjnwkd4cpdp2">
                info@viridiaanalytics.com
              </a>
            </li>
            <li className="flex items-start gap-2.5" data-id="element-291" data-mp="2pgo4ktkrgqit">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" aria-hidden="true" data-id="element-292" data-mp="2uidgebft587y" />
              <span data-id="element-293" data-mp="24u819f1kztup">
                Phoenix, AZ 85050
                <br data-id="element-294" data-mp="1zud6v1ilkm4w" />
                Serving the whole Valley
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#1a1a1a]" data-id="element-295" data-mp="2ekb0vy37k620">
        <div className="mx-auto flex w-full max-w-6xl flex-col gap-2 px-6 py-6 text-xs text-neutral-600 sm:flex-row sm:items-center sm:justify-between" data-id="element-296" data-mp="2el2l6crcuhcz">
          <p data-id="element-297" data-mp="2nimp5tglqrra">&copy; {new Date().getFullYear()} Viridia Analytics</p>
          <p className="font-mono uppercase tracking-[0.15em]" data-id="element-298" data-mp="2ilcsbsqvvdtf">Month to month &middot; No contracts</p>
        </div>
      </div>
    </footer>;
}